module.exports = __webpack_public_path__ + "static/slide-1-776cb5719356db8aa234337b7e17ec27.png";